import { render, staticRenderFns } from "./fixGrid.vue?vue&type=template&id=f0c993ba&scoped=true&"
import script from "./fixGrid.vue?vue&type=script&lang=js&"
export * from "./fixGrid.vue?vue&type=script&lang=js&"
import style0 from "./fixGrid.vue?vue&type=style&index=0&id=f0c993ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c993ba",
  null
  
)

export default component.exports